import DatetimeFormatter from "@/components/functionals/DatetimeFormatter.vue";
import ImagePerson from "@/components/functionals/ImagePerson.vue";
import ColorType from "@/components/functionals/ColorType.vue";

//import { formatMonto } from "@/utils";

export default [
  {
    prop: "Id",
    label: "NO",
    width: 70,
    align: "center",
    fixed: true,
    sortable: true
  },
  {
    prop: "Name",
    label: "Descripcion",
    width: 150,
    align: "center",
    sortable: true
  },
  {
    prop: "CustomerCode",
    label: "# Cliente",
    width: 150,
    align: "center",
    sortable: true
  },
  {
    prop: "ContactName",
    label: "Nombre Contacto",
    width: 150,
    align: "center",
    sortable: true
  },
  {
    prop: "Amount",
    label: "Monto Total",
    width: 150,
    align: "center",
    sortable: true,
    formatter: ColorType
  },
  {
    prop: "Quantity",
    label: "Cantidad",
    width: 150,
    align: "center",
    sortable: true,
    formatter: ColorType
  },
  {
    prop: "NameSalesPerson",
    label: "Vendedor",
    width: 150,
    align: "center",
    sortable: true,
    formatter: ImagePerson,
    attrs: {
      imgKey: "ImgSalesPerson"
    }
  },
  {
    prop: "InitialDate",
    label: "Fecha Inicial",
    formatter: DatetimeFormatter,
    width: 180
  },
  {
    prop: "FinalDate",
    label: "Fecha Final",
    formatter: DatetimeFormatter,
    width: 180
  }
];
